'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var connect = require('it-ws/client');

var mafmt = require('mafmt');

var withIs = require('class-is');

var toUri = require('multiaddr-to-uri');

var _require = require('abortable-iterator'),
    AbortError = _require.AbortError;

var log = require('debug')('libp2p:websockets');

var _createListener = require('./listener');

var toConnection = require('./socket-to-conn');

var _require2 = require('./constants'),
    CODE_CIRCUIT = _require2.CODE_CIRCUIT,
    CODE_P2P = _require2.CODE_P2P;
/**
 * @class WebSockets
 */


var WebSockets = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {object} options
   * @param {Upgrader} options.upgrader
   */
  function WebSockets(_ref) {
    var upgrader = _ref.upgrader;

    _classCallCheck(this, WebSockets);

    if (!upgrader) {
      throw new Error('An upgrader must be provided. See https://github.com/libp2p/interface-transport#upgrader.');
    }

    this._upgrader = upgrader;
  }
  /**
   * @async
   * @param {Multiaddr} ma
   * @param {object} [options]
   * @param {AbortSignal} [options.signal] Used to abort dial requests
   * @returns {Connection} An upgraded Connection
   */


  _createClass(WebSockets, [{
    key: "dial",
    value: function () {
      var _dial = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ma) {
        var options,
            socket,
            maConn,
            conn,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                log('dialing %s', ma);
                _context.next = 4;
                return this._connect(ma, options);

              case 4:
                socket = _context.sent;
                maConn = toConnection(socket, {
                  remoteAddr: ma,
                  signal: options.signal
                });
                log('new outbound connection %s', maConn.remoteAddr);
                _context.next = 9;
                return this._upgrader.upgradeOutbound(maConn);

              case 9:
                conn = _context.sent;
                log('outbound connection %s upgraded', maConn.remoteAddr);
                return _context.abrupt("return", conn);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function dial(_x) {
        return _dial.apply(this, arguments);
      }

      return dial;
    }()
    /**
     * @private
     * @param {Multiaddr} ma
     * @param {object} [options]
     * @param {AbortSignal} [options.signal] Used to abort dial requests
     * @returns {Promise<WebSocket>} Resolves a extended duplex iterable on top of a WebSocket
     */

  }, {
    key: "_connect",
    value: function () {
      var _connect2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ma) {
        var options,
            cOpts,
            rawSocket,
            onAbort,
            abort,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};

                if (!(options.signal && options.signal.aborted)) {
                  _context2.next = 3;
                  break;
                }

                throw new AbortError();

              case 3:
                cOpts = ma.toOptions();
                log('dialing %s:%s', cOpts.host, cOpts.port);
                rawSocket = connect(toUri(ma), Object.assign({
                  binary: true
                }, options));

                if (options.signal) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 9;
                return rawSocket.connected();

              case 9:
                log('connected %s', ma);
                return _context2.abrupt("return", rawSocket);

              case 11:
                abort = new Promise(function (resolve, reject) {
                  onAbort = function onAbort() {
                    reject(new AbortError());
                    rawSocket.close();
                  }; // Already aborted?


                  if (options.signal.aborted) return onAbort();
                  options.signal.addEventListener('abort', onAbort);
                });
                _context2.prev = 12;
                _context2.next = 15;
                return Promise.race([abort, rawSocket.connected()]);

              case 15:
                _context2.prev = 15;
                options.signal.removeEventListener('abort', onAbort);
                return _context2.finish(15);

              case 18:
                log('connected %s', ma);
                return _context2.abrupt("return", rawSocket);

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[12,, 15, 18]]);
      }));

      function _connect(_x2) {
        return _connect2.apply(this, arguments);
      }

      return _connect;
    }()
    /**
     * Creates a Websockets listener. The provided `handler` function will be called
     * anytime a new incoming Connection has been successfully upgraded via
     * `upgrader.upgradeInbound`.
     * @param {object} [options]
     * @param {http.Server} [options.server] A pre-created Node.js HTTP/S server.
     * @param {function (Connection)} handler
     * @returns {Listener} A Websockets listener
     */

  }, {
    key: "createListener",
    value: function createListener() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var handler = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        handler = options;
        options = {};
      }

      return _createListener({
        handler: handler,
        upgrader: this._upgrader
      }, options);
    }
    /**
     * Takes a list of `Multiaddr`s and returns only valid Websockets addresses
     * @param {Multiaddr[]} multiaddrs
     * @returns {Multiaddr[]} Valid Websockets multiaddrs
     */

  }, {
    key: "filter",
    value: function filter(multiaddrs) {
      multiaddrs = Array.isArray(multiaddrs) ? multiaddrs : [multiaddrs];
      return multiaddrs.filter(function (ma) {
        if (ma.protoCodes().includes(CODE_CIRCUIT)) {
          return false;
        }

        return mafmt.WebSockets.matches(ma.decapsulateCode(CODE_P2P)) || mafmt.WebSocketsSecure.matches(ma.decapsulateCode(CODE_P2P));
      });
    }
  }]);

  return WebSockets;
}();

module.exports = withIs(WebSockets, {
  className: 'WebSockets',
  symbolName: '@libp2p/js-libp2p-websockets/websockets'
});